import OrderCostSummaryPdfV2 from "../OrderCostSummaryPdfV2";

const OrderCostSummaryPdfV3 = OrderCostSummaryPdfV2;

export default OrderCostSummaryPdfV3;
